export { default as NewCorporateCardSlot } from './NewCorporateCardSlot';
